/* ------------------------------------------------------------------
   EmailCapture.js — shared email-capture card (public page + editor preview)
   On submit, POSTs to /api/bio/subscribe/:username → creates a CRM contact.
   `preview` disables submission (used inside the editor's live preview).
------------------------------------------------------------------ */
import React, { useState } from 'react';

export default function EmailCapture({ username, heading, buttonText, css = {}, preview = false }) {
  const [email, setEmail] = useState('');
  const [state, setState] = useState('idle'); // idle | loading | done | error
  const [err, setErr]     = useState('');

  async function submit(e) {
    e.preventDefault();
    if (preview) return;
    if (!email) return;
    setState('loading');
    try {
      const res = await fetch(`/api/bio/subscribe/${encodeURIComponent(username)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) {
        const d = await res.json().catch(() => ({}));
        throw new Error(d.error || 'Something went wrong');
      }
      setState('done');
    } catch (e2) {
      setErr(e2.message);
      setState('error');
    }
  }

  return (
    <form onSubmit={submit} style={{ width: '100%', marginTop: 24 }}>
      <div style={{ background: 'rgba(255,255,255,0.12)', border: '1px solid rgba(255,255,255,0.18)', borderRadius: 14, padding: 16 }}>
        {state === 'done' ? (
          <div style={{ textAlign: 'center', color: css.textColor || '#fff', fontWeight: 600, padding: '10px 0' }}>
            You're in! 🎉
          </div>
        ) : (
          <>
            <div style={{ color: css.textColor || '#fff', fontWeight: 700, fontSize: 15, textAlign: 'center', marginBottom: 10 }}>
              {heading || 'Join my list'}
            </div>
            <input
              type="email" required value={email} disabled={preview}
              onChange={e => setEmail(e.target.value)} placeholder="you@email.com"
              style={{ width: '100%', padding: '12px 14px', borderRadius: 10, border: 'none', fontSize: 14, boxSizing: 'border-box', marginBottom: 10, outline: 'none' }}
            />
            <button
              type="submit" disabled={state === 'loading' || preview}
              style={{ width: '100%', textAlign: 'center', padding: '13px', ...(css.button || {}), fontWeight: 600, fontSize: 15, cursor: preview ? 'default' : 'pointer' }}
            >
              {state === 'loading' ? 'Joining…' : (buttonText || 'Subscribe')}
            </button>
            {state === 'error' && (
              <div style={{ color: '#fee2e2', fontSize: 12, textAlign: 'center', marginTop: 8 }}>{err}</div>
            )}
          </>
        )}
      </div>
    </form>
  );
}
